import { Component, Inject, Input } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { HelloWidgetResponse } from './hello-widget.response';
import { RbacServiceInterface } from "../../services/rbac/rbac-service.interface";
import { Row } from "../table-facade/data.response";

@Component({
  selector: 'gtd-hello-widget-sidebar',
  templateUrl: './hello-widget-sidebar.component.html',
})
export class HelloWidgetSidebarComponent extends GtdNgWidgetComponentAbstract {
  @Input() subAffiliates: Row[] = [];
  public data: HelloWidgetResponse = new HelloWidgetResponse();
  protected readonly key: string = 'AffiliateCrm\\Dashboard\\Welcome';
  public logoPath = logoPath;
  public isOpen = true;
  public masterAffiliateToken: string;

  constructor(
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface,
  ) {
    super();

    const masterToken = localStorage.getItem('master-affiliate-token');
    const affiliateToken = localStorage.getItem('affiliate-token');
    if (masterToken !== affiliateToken) {
      this.masterAffiliateToken = masterToken;
    }
  }

  toggleSubAffiliates() {
    this.isOpen = !this.isOpen;
  }

  public returnToMaster(): void {
    const masterToken = localStorage.getItem('master-affiliate-token');
    localStorage.setItem('affiliate-token', masterToken);
    localStorage.removeItem('master-affiliate-token');
    window.open('/affiliates/app/dashboard', '_self');
  }
}

export const logoPath = 'assets/new-img/icons/user-pic.svg';
